export { WatchmanIntentionsRewardScreen as default } from '@/src/features/watchman/ui/screens/WatchmanIntentionsRewardScreen'
